{
  "lang": "nl",
  "alias": "rvr-wsnp",
  "theme": "bare",
  "master": "masters/bare/rvr-wsnp",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "all-or-nothing",
    "asterisk",
    "auto-next-when-only-radio",
    "bb-input-wrap-and-unit",
    "busy",
    "convert-metadata",
    "grid-tabs",
    "has-required",
    "headings",
    "high-on-info-tb",
    "history",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "metadata-change-navtext",
    "no-menu",
    "nonce-metatag",
    "nta:proxymap",
    "piwik-pro-nonce",
    "previews",
    "shout-out-resize",
    "show-server-side-validation",
    "skip",
    "user-error-focus-first",
    "wrap-table"
  ],
  "overrideinloghtml": "rvr-org.html",
  "arbitrary": {
    "headings": {
      "baseLevel": "2"
    },
    "core": {
      "skipNumButtons": true,
      "wrapAllSingleLiners": true,
      "putAddRowButtonBelowGrid": true,
      "form-group": {
        "on": true,
        "names": {
          "grouping-class": "form-group",
          "grouping-prefix-type-": "form-group-",
          "question-class": "form-group__question bb-questionlabelgroup",
          "question-prefix-type": "form-group__question-",
          "question-data-layout": "data-form-group-layout",
          "question-prefix-authorstyle": "form-group__question--author-style-"
        },
        "toplevel": true
      },
      "editPolicy": "return"
    },
    "info-inline": {
      "buttonplacement": "beforeend"
    },
    "previews": {
      "showChanges": true
    },
    "busy": {
      "on": "bb:prePost",
      "off": "bb:postHandleData bb:jsonError bb:hasUpdated"
    },
    "form-group": {
      "edit": "below",
      "numedit": "below",
      "checkbox": "inline",
      "datetimepicker": "below",
      "combobox": "below",
      "freebox": "below",
      "linklabel": "below",
      "listlabel": "below",
      "memo": "below",
      "checkmultilist": "below",
      "multilist": "below",
      "grid": "below",
      "listbox": "below",
      "radio": "below"
    },
    "parentDomain": [
      "https://www.rvr.org/"
    ],
    "shout-out-resize": {
      "leeway": 84
    },
    "title": "Raad voor Rechtsbijstand",
    "piwik": {
      "fallback": {
        "code": "1cb006c7-51c6-4a48-a7bf-ebd3e28b0fd1",
        "endpoint": "https://rvr.containers.piwik.pro/"
      }
    }
  },
  "template": {
    "less": {
      "post": [
        "rvr-org.less",
        "high-on-info-tb.less"
      ]
    },
    "themeColor": "#33587f",
    "readonly-prop": "disabled"
  },
  "legacy": false,
  "fonts": [
    "source-serif-pro-v11",
    "nunito-sans-v6"
  ]
}
